import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const FullWidthRow = styled(Row)`
  width: 100%;
`;

export const LabelPlacement = styled(Row)`
  margin-right: -10px;
`;
